// NotificacionesUsuario.js
import React, { useEffect, useState } from "react";
import { Card, Row, Col, Spinner, Button, Form, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import FirmaNotificacion from "../FirmaNotificacion";
import Header from "../Components/Header";

const BASE_URL = "https://sectorb12.info/api";

const NotificacionesUsuario = ({ onActualizarLeidas }) => {
  const [notificaciones, setNotificaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [notificacionParaFirmar, setNotificacionParaFirmar] = useState(null);
  const [filtro, setFiltro] = useState("todas");
  const [modalSubsanacion, setModalSubsanacion] = useState(false);
  const [notificacionSubsanacion, setNotificacionSubsanacion] = useState(null);
  const [fileBase64, setFileBase64] = useState("");
  const [nombreDocumento, setNombreDocumento] = useState("");
  const [enviandoSubsanacion, setEnviandoSubsanacion] = useState(false);

  const usuarioId = localStorage.getItem("id");
  const token = localStorage.getItem("token");

  const fetchNotificaciones = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/notificaciones/usuarios/${usuarioId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (!response.ok) throw new Error("Error al obtener las notificaciones");
      const data = await response.json();

      const dataConSolicitudes = await Promise.all(
        data.map(async (noti) => {
          if (noti.SolicitudID) {
            try {
              const res = await fetch(`${BASE_URL}/solicitudes/${noti.SolicitudID}`, {
                headers: { Authorization: `Bearer ${token}` },
              });
              if (res.ok) {
                const solicitud = await res.json();
                return { ...noti, SolicitudDescripcion: solicitud.Descripcion };
              }
            } catch (e) {
              console.error("Error obteniendo solicitud:", e);
            }
          }
          return { ...noti, SolicitudDescripcion: null };
        })
      );

      setNotificaciones(dataConSolicitudes);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotificaciones();
  }, [usuarioId]);

  const abrirModalFirma = (notificacion) => {
    const fechaActual = new Date();
    setNotificacionParaFirmar({
      ...notificacion,
      FechaEnvio: new Date(notificacion.FechaEnvio).toISOString().split("T")[0],
      FechaFirma: fechaActual.toISOString().split("T")[0],
      FechaRecepcion: fechaActual.toISOString().replace("T", " ").split(".")[0],
    });
    setMostrarModal(true);
  };

  const cerrarModalFirma = () => {
    setMostrarModal(false);
    setNotificacionParaFirmar(null);
    fetchNotificaciones();
    if (typeof onActualizarLeidas === "function") onActualizarLeidas();
  };

  const handleDownload = (doc) => {
    const binaryData = atob(doc);
    const blob = new Blob([new Uint8Array(binaryData.split("").map((c) => c.charCodeAt(0)))]);
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "documento.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const abrirModalSubsanacion = (notificacion) => {
    setNotificacionSubsanacion(notificacion);
    setModalSubsanacion(true);
    setFileBase64("");
    setNombreDocumento("");
  };

  const handleFileSubsanacion = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNombreDocumento(file.name);
      const reader = new FileReader();
      reader.onload = () => setFileBase64(reader.result.split(",")[1]);
      reader.readAsDataURL(file);
    }
  };

  const enviarSubsanacion = async () => {
    if (!fileBase64) { alert("Por favor adjunte un documento."); return; }
    setEnviandoSubsanacion(true);
    try {
      const res = await fetch(
        `${BASE_URL}/notificaciones/${notificacionSubsanacion.NotificacionID}/subsanacion`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            NombreDocumento: nombreDocumento,
            Documento: fileBase64,
          }),
        }
      );
      if (res.ok) {
        alert("Documentación adicional enviada correctamente.");
        setModalSubsanacion(false);
        fetchNotificaciones();
      } else {
        alert("Error al enviar la documentación.");
      }
    } catch {
      alert("No se pudo conectar con el servidor.");
    } finally {
      setEnviandoSubsanacion(false);
    }
  };

  const renderTitulo = (notificacion) => {
    if (notificacion.Tipo === "subsanacion") return (
      <span className="text-warning fw-bold">
        <i className="bi bi-exclamation-triangle me-1"></i> Subsanación requerida
      </span>
    );
    if (notificacion.Tipo === "justificante") return (
      <span className="text-success fw-bold">
        <i className="bi bi-check-circle me-1"></i> Justificante de registro
      </span>
    );
    return <span className="text-success">Notificación</span>;
  };

  return (
    <div className="d-flex flex-column">
      <Header />
      <h4 className="mt-4 mb-2">
        <i className="bi bi-envelope text-success"></i> Notificaciones
      </h4>
      <p className="text-muted mb-4">
        Consulte y firme sus notificaciones recibidas a través de la Oficina Virtual.
      </p>

      <div className="mb-3">
        {["todas", "firmadas", "pendientes"].map((f) => (
          <Button
            key={f}
            variant={filtro === f ? "success" : "outline-success"}
            size="sm"
            className="me-2"
            onClick={() => setFiltro(f)}
          >
            {f.charAt(0).toUpperCase() + f.slice(1)}
          </Button>
        ))}
      </div>

      {loading ? (
        <div className="text-center">
          <Spinner animation="border" />
          <p className="mt-3">Cargando notificaciones...</p>
        </div>
      ) : error ? (
        <p className="text-danger text-center">{error}</p>
      ) : notificaciones.length === 0 ? (
        <p className="text-center">No tienes notificaciones.</p>
      ) : (
        <Row>
          {notificaciones
            .filter((n) => {
              if (filtro === "firmadas") return n.Firmado;
              if (filtro === "pendientes") return !n.Firmado;
              return true;
            })
            .map((notificacion) => (
              <Col md={12} key={notificacion.NotificacionID} className="mb-4">
                <Card className={`shadow-sm h-100 ${notificacion.Tipo === "subsanacion" ? "border-warning" : ""}`}>
                  <Card.Body>
                    <Card.Title className="fs-6">{renderTitulo(notificacion)}</Card.Title>
                    {notificacion.Asunto && (
                      <div className="fw-semibold mb-1">{notificacion.Asunto}</div>
                    )}
                    <div className="mb-2 text-muted small">
                      Recibida el {new Date(notificacion.FechaEnvio).toLocaleDateString("es-ES", {
                        year: "numeric", month: "long", day: "numeric",
                      })}
                    </div>
                    {notificacion.SolicitudDescripcion && (
                      <div className="mb-2">
                        <strong>Solicitud relacionada:</strong> {notificacion.SolicitudDescripcion}
                      </div>
                    )}
                    <div className="mt-2" style={{ color: notificacion.Firmado ? "inherit" : "red" }}>
                      {notificacion.Firmado ? (
                        <p>{notificacion.Descripcion}</p>
                      ) : (
                        "Esta notificación requiere firma electrónica para visualizarse."
                      )}
                    </div>

                    {notificacion.Firmado && notificacion.Documentos && (
                      <div className="mt-2">
                        <Button variant="outline-success" size="sm" onClick={() => handleDownload(notificacion.Documentos)}>
                          <i className="bi bi-download me-1"></i> Ver documento
                        </Button>
                      </div>
                    )}
                  </Card.Body>
                  <Card.Footer className="d-flex justify-content-between align-items-center gap-2">
                    {notificacion.Firmado ? (
                      <Button variant="success" disabled size="sm">
                        <i className="bi bi-check-lg me-1"></i> Notificación firmada
                      </Button>
                    ) : (
                      <Button variant="success" size="sm" onClick={() => abrirModalFirma(notificacion)}>
                        <i className="bi bi-pencil-square me-1"></i> Firmar notificación
                      </Button>
                    )}

                    {notificacion.Tipo === "subsanacion" && notificacion.Firmado && !notificacion.Subsanada && (
                      <Button variant="warning" size="sm" onClick={() => abrirModalSubsanacion(notificacion)}>
                        <i className="bi bi-paperclip me-1"></i> Aportar documentación
                      </Button>
                    )}
                  </Card.Footer>
                </Card>
              </Col>
            ))}
        </Row>
      )}

      {mostrarModal && notificacionParaFirmar && (
        <FirmaNotificacion notificacion={notificacionParaFirmar} onFirmada={cerrarModalFirma} />
      )}

      {/* Modal subsanación */}
      <Modal show={modalSubsanacion} onHide={() => setModalSubsanacion(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Aportar documentación adicional</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted">
            Adjunte el documento requerido para la subsanación de su solicitud.
          </p>
          <Form.Group>
            <Form.Label>Documento</Form.Label>
            <Form.Control type="file" accept=".pdf" onChange={handleFileSubsanacion} />
          </Form.Group>
          {nombreDocumento && (
            <p className="mt-2 text-success small">
              <i className="bi bi-check-circle me-1"></i> {nombreDocumento}
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalSubsanacion(false)}>Cancelar</Button>
          <Button variant="success" onClick={enviarSubsanacion} disabled={enviandoSubsanacion || !fileBase64}>
            {enviandoSubsanacion ? "Enviando..." : "Enviar documentación"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default NotificacionesUsuario;